import React from 'react';
import OrderCancelList from '../OrderCancelList';
import OrderCancelListSearchBox from '../OrderCancelListSearchBox';
import OrderCancelListSummaryBox from '../OrderCancelListSummaryBox';

const OrderCancelListWrap = (props) => {
  const { setData, orderCancelList, getList, getExcelDownload, mainProductCategorySelectList } = props;

  return (
    <div className="order-cancel-list-wrap">
      {/*주문 취소 집계 정보*/}
      <OrderCancelListSummaryBox orderCancelSummaryBox={orderCancelList.orderCancelSummaryBox} />

      {/*주문 취소 서치 박스*/}
      <OrderCancelListSearchBox
        setData={(data) =>
          setData({
            path: ['orderCancelList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={orderCancelList.searchData}
        getList={getList}
      />

      {/* 주문 취소 리스트 */}
      <OrderCancelList
        orderCancelList={orderCancelList}
        mainProductCategorySelectList={mainProductCategorySelectList}
        getList={getList}
        getExcelDownload={getExcelDownload}
      />
    </div>
  );
};

export default OrderCancelListWrap;
